import { Button } from "@mui/material";

import withStyles from "@mui/styles/withStyles";

export const ColorButton = withStyles((theme) => ({
  root: {
    color: "#0091FF",
    border: "1px solid",
    borderRadius: 20,
    fontWeight: "bold",
    width: 125,
    marginRight: 30,
    textTransform: "none",

    "&:hover": {
      color: "white",
      backgroundColor: "#0091FF",
    },
  },
}))(Button);

export const DoneButton = withStyles((theme) => ({
  root: {
    color: "#0091FF",
    border: "1px solid",
    padding: "2px 16px",
    borderRadius: 20,
    fontSize: 10,
    fontWeight: "bold",
    textTransform: "none",
    "&:hover": {
      color: "white",
      backgroundColor: "#0091FF",
    },
  },
}))(Button);

export const ColorButton2 = withStyles((theme) => ({
  root: {
    color: "white",
    borderRadius: 20,
    width: 125,
    fontWeight: "bold",
    textTransform: "none",
    backgroundColor: "#0091FF",
    "&:hover": {
      backgroundColor: "#0091FF",
    },
  },
}))(Button);

export const WideColorButton = withStyles((theme) => ({
  root: {
    color: "#0091FF",
    border: "1px solid",
    borderRadius: 20,
    fontWeight: "bold",
    padding: "8px 32px",
    textTransform: "none",

    "&:hover": {
      color: "white",
      backgroundColor: "#0091FF",
    },
  },
}))(Button);
